module.exports = __webpack_public_path__ + "img/foto condell 2.36b72cd4.jpg";